import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import es from './locales/es.json';

const resources = {
  en: {
    translation: en
  },
  es: {
    translation: es
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // default language - Spanish
    fallbackLng: 'es',
    
    interpolation: {
      escapeValue: false // react already does escaping
    }
  });

export default i18n;
